module.exports = __webpack_public_path__ + "static/media/wedding.ba3a560b.pdf";